import {vec3, mat4} from '../beam/index';

import settings from './settings';


//From: https://github.com/mrdoob/three.js/blob/master/examples/jsm/math/MeshSurfaceSampler.js

class Triangle {
    constructor( a, b, c ) {
		this.a = ( a !== undefined ) ? a : vec3.create();
		this.b = ( b !== undefined ) ? b : vec3.create();
		this.c = ( c !== undefined ) ? c : vec3.create();
    }
    getArea() {
		vec3.subtract( _v0, this.c, this.b );
		vec3.subtract( _v1, this.a, this.b );
        vec3.cross( _v0, _v0, _v1 )
        return vec3.length(_v0) * 0.5;
	}
}

let _v0 = vec3.create()
let _v1 = vec3.create()
var _face  = new Triangle()
var targetPosition = vec3.create()
let scaledFace = vec3.create()

export default class MeshSurfaceSampler {

	constructor(positions) {
		this.positions      = positions;
        var numPoints       = this.positions.length/3;
        var numFaces        = numPoints/3;
        var faceWeights     = new Float32Array( numFaces );
        // Accumulate weights for each mesh face.
        for ( var i = 0; i < (numFaces); i ++ ) {//+=3 -> 3 points per face
            var faceWeight = 1;
            var faceIndex = i;
            vec3.set(_face.a, this.positions[(faceIndex*3+0) * 3 + 0], this.positions[(faceIndex*3+0) * 3 + 1], this.positions[(faceIndex*3+0) * 3 + 2]  );
            vec3.set(_face.b, this.positions[(faceIndex*3+1) * 3 + 0], this.positions[(faceIndex*3+1) * 3 + 1], this.positions[(faceIndex*3+1) * 3 + 2]  );
            vec3.set(_face.c, this.positions[(faceIndex*3+2) * 3 + 0], this.positions[(faceIndex*3+2) * 3 + 1], this.positions[(faceIndex*3+2) * 3 + 2]  );
            
            faceWeight *= _face.getArea();
            
            let wA = 1. - Math.pow( Math.min(1, vec3.length( _face.a ) / settings.maxWheatDistance), 4)
            let wB = 1. - Math.pow( Math.min(1, vec3.length( _face.b ) / settings.maxWheatDistance), 4)
            let wC = 1. - Math.pow( Math.min(1, vec3.length( _face.c ) / settings.maxWheatDistance), 4)
            faceWeight *= (wA+wB+wC)/3;

            faceWeights[ i ] = faceWeight;
        }
        // Store cumulative total face weights in an array, where weight index
        // corresponds to face index.
        this.distribution = new Float32Array( (numPoints) / 3 );
        var cumulativeTotal = 0;
        for ( var i = 0; i < faceWeights.length; i ++ ) {
            cumulativeTotal += faceWeights[ i ];
            this.distribution[ i ] = cumulativeTotal;
        }
    }

    binarySearch ( x ) {
        var dist  = this.distribution;
        var start = 0;
        var end   = dist.length - 1;
        var index = - 1;
        while ( start <= end ) {
            var mid = Math.ceil( ( start + end ) / 2 );
            if ( mid === 0 || dist[ mid - 1 ] <= x && dist[ mid ] > x ) {
                index = mid;
                break;
            } else if ( x < dist[ mid ] ) {
                end = mid - 1;
            } else {
                start = mid + 1;
            }
        }
        return index;
    }


    sample () {
        var cumulativeTotal = this.distribution[ this.distribution.length - 1 ];
        var faceIndex = this.binarySearch( Math.random() * cumulativeTotal );

        var u = Math.random();
        var v = Math.random();
        if ( u + v > 1 ) {
            u = 1 - u;
            v = 1 - v;
        }

        vec3.set(_face.a, this.positions[(faceIndex*3+0) * 3 + 0], this.positions[(faceIndex*3+0) * 3 + 1], this.positions[(faceIndex*3+0) * 3 + 2]  );
        vec3.set(_face.b, this.positions[(faceIndex*3+1) * 3 + 0], this.positions[(faceIndex*3+1) * 3 + 1], this.positions[(faceIndex*3+1) * 3 + 2]  );
        vec3.set(_face.c, this.positions[(faceIndex*3+2) * 3 + 0], this.positions[(faceIndex*3+2) * 3 + 1], this.positions[(faceIndex*3+2) * 3 + 2]  );

        vec3.set( targetPosition, 0, 0, 0 )
        
        vec3.copy( scaledFace, _face.a )
        vec3.scale( scaledFace, scaledFace, u )
        vec3.add( targetPosition, targetPosition, scaledFace )

        vec3.copy( scaledFace, _face.b )
        vec3.scale( scaledFace, scaledFace, v )
        vec3.add( targetPosition, targetPosition, scaledFace )

        vec3.copy( scaledFace, _face.c )
        vec3.scale( scaledFace, scaledFace, 1 - ( u + v ) )
        vec3.add( targetPosition, targetPosition, scaledFace )
        
        return targetPosition;
    }

}